import { defineMessages } from "@/i18n";
import en from "./en";

export const inputBarStandaloneMessages = defineMessages(
  "input-bar-standalone",
  en,
);
